/** @format */

import { useState } from "react";
var useFormValidation = function useFormValidation() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useState = useState({}),
    errors = _useState[0],
    setErrors = _useState[1];
  var required = function required(value) {
    return !value;
  };
  var phoneNumber = function phoneNumber(value) {
    return !/^(05)[0-9]{8}$/.test(value);
  };
  var minChar = function minChar(value, min) {
    return value.length <= min;
  };
  var maxChar = function maxChar(value, max) {
    return value.length > max;
  };
  var minMaxChar = function minMaxChar(value, min, max) {
    return value.length < min || value.length > max;
  };
  var minNumber = function minNumber(value, min) {
    return value < min;
  };
  var minMaxNumber = function minMaxNumber(value, min, max) {
    return value < min || value > max;
  };
  var minMilage = function minMilage(value, is_milage) {
    var minDistance = is_milage ? 62 : 100;
    return value < minDistance;
  };
  var minArray = function minArray(value, min) {
    return value.length < min;
  };
  var sameNumber = function sameNumber(value, oldValue) {
    return value == oldValue;
  };
  var IDNumber = function IDNumber(value, length, startingWith) {
    var result = value.length !== length && (value[0] !== startingWith[0] || value[0] !== startingWith[1]);
    return result;
  };
  var validate = function validate() {
    var localErrors = {};
    fields.forEach(function (_ref) {
      var field = _ref.field,
        value = _ref.value,
        oldValue = _ref.oldValue,
        validation = _ref.validation,
        isOptional = _ref.isOptional;
      validation.forEach(function (_ref2) {
        var name = _ref2.name,
          message = _ref2.message,
          min = _ref2.min,
          max = _ref2.max,
          is_milage = _ref2.is_milage,
          messageKM = _ref2.messageKM,
          messageMILE = _ref2.messageMILE,
          length = _ref2.length,
          startingWith = _ref2.startingWith;
        if (!localErrors[field]) switch (name) {
          case "required":
            if (isOptional) {
              break;
            }
            if (required(value)) localErrors[field] = message;
            break;
          case "phoneNumber":
            if (phoneNumber(value)) localErrors[field] = message;
            break;
          case "minChar":
            if (minChar(value, min)) localErrors[field] = message;
            break;
          case "maxChar":
            if (!value) {
              break;
            }
            if (maxChar(value, max)) localErrors[field] = message;
            break;
          case "minMaxChar":
            if (minMaxChar(value, min, max)) localErrors[field] = message;
            break;
          case "minNumber":
            if (isOptional) {
              break;
            }
            if (minNumber(value, min)) {
              localErrors[field] = message;
            }
            break;
          case "minMaxNumber":
            console.log("passed");
            if (isOptional) {
              break;
            }
            if (minMaxNumber(value, min, max)) {
              localErrors[field] = message;
            }
            break;
          case "minArray":
            if (minArray(value, min)) localErrors[field] = message;
            break;
          case "minMilage":
            if (isOptional) {
              break;
            }
            if (minMilage(value, is_milage)) {
              if (is_milage) {
                localErrors[field] = messageMILE;
              } else {
                localErrors[field] = messageKM;
              }
            }
            break;
          case "sameNumber":
            if (sameNumber(value, oldValue)) localErrors[field] = message;
            break;
          case "IDNumber":
            if (IDNumber(value, length, startingWith)) {
              localErrors[field] = message;
            }
        }
      });
    });
    setErrors(localErrors);
    return Object.keys(localErrors).length == 0;
  };
  return [errors, validate];
};
export default useFormValidation;